module.exports = __webpack_public_path__ + "static/media/copyright-notice.eef0053a.jpg";